/**
 * Supported language codes for the Ling Database SDK
 */
export const SUPPORTED_LANGUAGES = [
  "th",
  "fil",
  "vi",
  "km",
  "sr",
  "lt",
  "ja",
  "ko",
  "zh",
  "de",
  "en",
  "it",
  "fr",
  "es",
  "ru",
  "ms",
  "ar",
  "no",
  "nl",
  "el",
  "ne",
  "hu",
  "pt",
  "sk",
  "sw",
  "ur",
  "cs",
  "hi",
  "in",
  "tr",
  "fi",
  "hr",
  "ro",
  "da",
  "bg",
  "bn",
  "pl",
  "fa",
  "ka",
  "te",
  "ta",
  "my",
  "mn",
  "af",
  "sv",
  "he",
  "ml",
  "pu",
  "et",
  "yue",
  "kn",
  "lv",
  "sl",
  "zh-TW",
  "sq",
  "bs",
  "uk",
  "hy",
  "ga",
  "lo",
  "mr",
  "sb",
  "ca",
  "am",
  "gu",
  "ps",
  "yo",
  "is",
  "so",
  "ceb",
  "si",
  "uz",
  "kk",
  "su",
  "jv",
  "nan",
  "az",
  "mi",
  "ilo",
] as const;

/**
 * Type representing a supported language code
 */
export type LanguageCode = typeof SUPPORTED_LANGUAGES[number];

/**
 * Word ID type - plain string identifier.
 * Typically `a` followed by 7 digits (e.g., `a0101005`), but kept as a string
 * for flexibility to support future features (e.g., unique courses).
 */
export type WordId = string;